<template>
  <div class="title-about inline-block md:px-0 lg:px-0 xl:px-0 2xl:px-0">
    <div class="justify-start text-emerald-700 text-xl md:text-3xl font-semibold leading-normal">
      {{ title }}
    </div>
    <div class="border-t-2 border-amber-400 mt-1 w-full"></div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  title: {
    type: String,
    required: true
  }
})
</script>
